<template>
	<div class="cruiseOrderList">
		<back-to></back-to>
		<van-tabs @click="onClick" v-model="current">
			<van-tab v-for="(item,index) in allTitle" :key="index" :title="item.name+'('+item.count+')'">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
					:immediate-check="false" class="cruiseOrderList-list">
					<div class="cruiseOrderList-item" v-for="(item,index) in list"
						@click="$router.push({ path: '/cruiseOrderDetail',query:{'orderId':item.orderId}})">
						<span class="cruiseOrderList-item_top">
							<p>团期:{{item.tour_no}}</p>
							<p>{{item.departure}}出发</p>
						</span>
						<span class="cruiseOrderList-item_center">
							<img :src="item.productImage" alt="">
							<label for="">
								<h2>{{item.productName}}</h2>
								<p>舱型：{{item.cabinName}}丨成人×{{item.num}}</p>
								<p>出发日期：{{item.sendDate|formateDate}} 联系人：{{item.contract}}</p>
							</label>
						</span>
						<span class="cruiseOrderList-item_bottom">
							<p>实付款：</p>
							<p>￥{{item.price}}</p>
						</span>
					</div>
				</van-list>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	import {
		formatTime
	} from '@/config/util'
	import {
		Toast
	} from 'vant'
	export default {
		name: 'cruiseOrderList',
		components: {
			BackTo
		},
		data() {
			return {
				current: 0,
				loading: false,
				finished: false,
				pageIndex: 1,
				allTitle: [{
					name: '全部',
					count: 0,
					id: 0
				}, {
					name: '补充资料',
					count: 0,
					id: 10
				}, {
					name: '签署合同',
					count: 0,
					id: 8
				}, {
					name: '待出行',
					count: 0,
					id: 3
				}, {
					name: '出行中',
					count: 0,
					id: 4
				}, {
					name: '已完成',
					count: 0,
					id: 6
				}],
				list: []
			}
		},
		created() {

		},
		filters: {
			formateDate(time) {
				let date = new Date(time)
				return formatTime(date)
			}
		},
		mounted() {
			this.getList()
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		methods: {
			onLoad() {
				setTimeout(() => {
					this.loading = false;
					this.pageIndex = this.pageIndex + 1
					this.getList()
				}, 500);
			},
			getList(e) {
				var data = {
					"pageIndex": this.pageIndex,
					"pageSize": 10,
					"userId": this.userInfo.userId,
					"orgId": this.$organizationId,
					"status": this.allTitle[this.current].id
				}
				this.$post(
					this.$domainUrl + '/ShipApp/GetShipOrderList', data
				).then(res => {
					var arrobj = this.allTitle
					if (this.current == 0) {
						for (var i in arrobj) {
							for (var k in res.statusCounts) {
								if (arrobj[i].id == res.statusCounts[k].status) {
									arrobj[i].count = res.statusCounts[k].count
								}
							}
						}
					}
					this.allTitle = arrobj
					if (e) {
						this.list = res.data
					} else {
						this.list = this.list.concat(res.data)
					}
					if (res.data.length < 10) {
						this.finished = true;
					}
				})
			},
			onClick() {
				window.scrollTo(0, 0)
				this.loading = false
				this.finished = false
				this.pageIndex = 1
				this.getList(true)
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.cruiseOrderList-list {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.cruiseOrderList-item {
		width: 100%;
		background-color: #fff;
		border-radius: 16px;
		padding: 24px 30px;
		box-sizing: border-box;
		margin-bottom: 20px;
	}

	.cruiseOrderList-item_top {
		display: flex;
		align-self: center;
		justify-content: space-between;
		font-size: 26px;
		color: #999999;
		border-bottom: 2px solid #F5F5F5;
		padding-bottom: 24px;
	}

	.cruiseOrderList-item_bottom {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		font-size: 26px;
		color: #666666;
		padding-top: 24px;
		border-top: 1px solid #F5F5F5;
	}

	.cruiseOrderList-item_bottom p:last-child {
		font-size: 30px;
		color: #FF4409;
	}

	.cruiseOrderList-item_center {
		width: 100%;
		padding: 20px 0;
	}

	.cruiseOrderList-item_center,
	.cruiseOrderList-item_center p {
		display: flex;
	}

	.cruiseOrderList-item_center img {
		width: 168px;
		height: 168px;
	}

	.cruiseOrderList-item_center label {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		font-size: 26px;
		color: #999999;
		line-height: 1.5;
		padding-left: 14px;
		box-sizing: border-box;
		height: 168px;
	}

	.cruiseOrderList-item_center h2 {
		font-size: 30px;
		color: #535353;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		font-weight: normal;
		margin-bottom: auto;
	}
</style>
